export const colors = {
    primary: '#2d276d',
    blue: '#547dff',
    lightBlue: '#b0c5ff',
    borderPrimary: '#011e98',
    secondary: '#fdcb44',
    orange: '#ffad33',
    borderTable: '#aec2ee',
    yellow: '#fbe98b',
    red: '#ea1210',
    gray: '#4e5461',
    lottery: '#1546da',
    darkPrimary: '#038787',
    white: '#fff',
    black: '#000',
    tabs: '#8f99a3',
    blackText: '#1a202c',
    success: '#0fa215',
    btnplay: 'linear-gradient(to bottom, #FFC935, #FF9901)',
    bgPopupDrak: '#222939',
    drak50: 'rgba(3, 10, 28, 0.5)',
    bgTitle: '#1e2c41',
    'gradient-primary': 'linear-gradient(192deg, #ffad33 9.53%, #de4300 132.11%)',
    'gradient-secondary': 'linear-gradient(180deg, #10acd3 0%, #461bf4 99.37%)',
    'gradient-popup': 'linear-gradient(269deg, rgba(67, 47, 92, 0.74) 23.94%, rgba(21, 41, 111, 0.68) 83.16%)',
};
